import { Link } from "react-router-dom";
import {
  FacebookIcon,
  IgIcon,
  LinkedInIcon,
  LogoIcon,
  Tiktok,
  XIcon,
  YoutubeIcon,
} from "../../assets/icon";

export const Footer: React.FC = () => {
  return (
    <footer className="relative bg-white mt-20 py-8  before:content-[''] before:absolute before:top-[-30px] before:left-0 before:right-0 before:h-[30px] before:bg-gradient-to-b before:from-transparent before:to-white">
      <div className="max-w-7xl px-[20px] lg:px-[120px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 mb-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <LogoIcon />
            </div>
            <p className="text-[12px] lg:text-[18px] text-gray-700 leading-relaxed mb-6">
              Share what you love, earn cash. Turn your
              <br className="hidden lg:block" /> recommendations into real earnings with <br className="hidden lg:block" /> trusted
              word-of-mouth.
            </p>

            <div className="flex gap-3 mb-6 ">
              <Link
                to="https://www.facebook.com/vouchlinks"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FacebookIcon />
              </Link>
              <Link
                to="https://x.com/vouchlinks"
                rel="noopener noreferrer"
                target="_blank"
              >
                <XIcon />
              </Link>
              <Link
                to="https://www.instagram.com/vouchlinks/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <IgIcon />
              </Link>
              {/* <Link
                to="#"
                rel="noopener noreferrer"
                target="_blank"
              >
                <YoutubeIcon />
              </Link> */}
              <Link
                to="http://linkedin.com/company/vouchlinks/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <LinkedInIcon />
              </Link>
              <Link
                to="https://www.tiktok.com/@vouchlinks"
                rel="noopener noreferrer"
                target="_blank"
              >
                <Tiktok />
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-[14px] lg:text-[16px]">
              Useful Links
            </h3>
            <ul className="space-y-3 text-[12px] lg:text-[14px]  text-gray-700">

              <li>
                <Link to={`https://www.vouchlinks.com/contact`} className="hover:text-emerald-500 underline transition">
                  Contact Us
                </Link>
              </li>

            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-[14px] lg:text-[16px]">
              Legal
            </h3>
            <ul className="space-y-3 text-[12px] lg:text-[14px] text-gray-700">
              <li>
                <Link to={`https://www.vouchlinks.com/privacy`} className="hover:text-emerald-500 underline transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={`https://www.vouchlinks.com/terms`} className="hover:text-emerald-500 underline transition">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to={`https://www.vouchlinks.com/credit`} className="hover:text-emerald-500 underline transition">
                  Credit & Contributions
                </Link>
              </li>
              <li>
                <Link to={`https://www.vouchlinks.com/cookies`} className="hover:text-emerald-500 underline transition">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to={`https://www.vouchlinks.com/referral/program`} className="hover:text-emerald-500 underline transition">
                  Referral Program T&Cs
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-[14px] lg:text-[16px]">
              Our Locations
            </h3>
            <h3 className="space-y-3 text-[12px] lg:text-[14px]  text-gray-700">

              London, United Kingdom
              86-90 Paul Street, London, EC2A
              4NE


            </h3>

            <h3 className="space-y-3 mt-6 text-[12px] lg:text-[14px]  text-gray-700">
              Lagos, Nigeria
              4a Kudeti Street, Lagos, 100282

            </h3>

          </div>
        </div>

        <div>
          <p className="text-sm text-gray-600 ">
            © 2026 VouchLinks. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
